import SingleUserRow from "./singleUserRow";

export default SingleUserRow;
